import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/Icon_Puffercat_Apps.png'
import _imports_1 from '../assets/Puffercat_Apps_Guide_1.png'
import _imports_2 from '../assets/Puffercat_Apps_Guide_2.png'
import _imports_3 from '../assets/Puffercat_Apps_Guide_3.png'
import _imports_4 from '../assets/Puffercat_Apps_Guide_4.png'
import _imports_5 from '../assets/Puffercat_Apps_Guide_5.png'
import _imports_6 from '../assets/Puffercat_Apps_Guide_6.png'
import _imports_7 from '../assets/Puffercat_Apps_Guide_7.png'
import _imports_8 from '../assets/Puffercat_Apps_Guide_8.png'
import _imports_9 from '../assets/Screenshot_Puffercat_Apps_1.jpg'
import _imports_10 from '../assets/Screenshot_Puffercat_Apps_2.jpg'
import _imports_11 from '../assets/Screenshot_Puffercat_Apps_3.jpg'
import _imports_12 from '../assets/Screenshot_Puffercat_Apps_4.jpg'
import _imports_13 from '../assets/Screenshot_Puffercat_Apps_5.png'
import _imports_14 from '../assets/Screenshot_Puffercat_Apps_6.png'
import _imports_15 from '../assets/Screenshot_Puffercat_Apps_7.png'
import _imports_16 from '../assets/Screenshot_Puffercat_Apps_8.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_column = _resolveComponent("ion-column")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Puffercat Apps", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("Puffercat Apps", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "column-standard2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "bannerColumn" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "auto" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "icon"
                      }, null, -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "auto",
                    class: "description-column"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { style: {"padding":"0px","margin":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, { style: {"padding":"0px","margin":"0px"} }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("p", {
                                class: "size-appname",
                                style: {"padding":"0px","margin":"0px"}
                              }, [
                                _createElementVNode("strong", null, "Puffercat Apps")
                              ], -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, null, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createElementVNode("p", { class: "size-appname-icon" }, "version 1.0.0-b7 (Beta 7)", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.logoPwa,
                                class: "size-appname-icon"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        id: "installPuffercatApps_AppPage",
                        expand: "full",
                        shape: "round",
                        style: {"margin":"0px"}
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("Download", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_modal, {
                        ref: "modal",
                        trigger: "installPuffercatApps_AppPage"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_toolbar, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_title, null, {
                                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                      _createTextVNode("Install Puffercat Apps", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_button, {
                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss()))
                                      }, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                          _createTextVNode("Close", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_content, { class: "ion-padding" }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createElementVNode("h2", null, "Guide for Chrome for Android", -1),
                              _createElementVNode("h4", null, "For other browsers, search \"Install PWA [name of your browser]\" in your search engine of choice", -1),
                              _createElementVNode("p", null, [
                                _createTextVNode("1. Go to \""),
                                _createElementVNode("a", { href: "https://apps.puffercat.xyz" }, "https://apps.puffercat.xyz"),
                                _createTextVNode("\".")
                              ], -1),
                              _createElementVNode("img", {
                                src: _imports_1,
                                class: "installGuideImage"
                              }, null, -1),
                              _createElementVNode("p", null, "2. Open the menu (on the browser's bar, not on the website)", -1),
                              _createElementVNode("img", {
                                src: _imports_2,
                                class: "installGuideImage"
                              }, null, -1),
                              _createElementVNode("p", null, "3. Select \"Add to home screen\"", -1),
                              _createElementVNode("img", {
                                src: _imports_3,
                                class: "installGuideImage"
                              }, null, -1),
                              _createElementVNode("p", null, "4. Select \"Install\"", -1),
                              _createElementVNode("img", {
                                src: _imports_4,
                                class: "installGuideImage"
                              }, null, -1),
                              _createElementVNode("p", null, "5. Select \"Install\" once again", -1),
                              _createElementVNode("img", {
                                src: _imports_5,
                                class: "installGuideImage"
                              }, null, -1),
                              _createElementVNode("p", null, "6. Done. You should get this notification and a new icon should show up on your home screen", -1),
                              _createElementVNode("img", {
                                src: _imports_6,
                                class: "installGuideImage"
                              }, null, -1),
                              _createElementVNode("img", {
                                src: _imports_7,
                                class: "installGuideImage"
                              }, null, -1),
                              _createElementVNode("p", null, "Now you can use Puffercat Apps like an app", -1),
                              _createElementVNode("img", {
                                src: _imports_8,
                                class: "installGuideImage"
                              }, null, -1),
                              _createElementVNode("br", null, null, -1),
                              _createElementVNode("br", null, null, -1),
                              _createElementVNode("br", null, null, -1),
                              _createElementVNode("br", null, null, -1),
                              _createElementVNode("br", null, null, -1),
                              _createElementVNode("br", null, null, -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Changelog - 1.0.0-b7")
                      ], -1),
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", { href: "https://x.com/rauchg/status/1972669025525158031" }, "Switched hosting providers from Vercel to Netlify")
                        ]),
                        _createElementVNode("li", null, "Added Alternate mirrors, AppGallery and Google Play links to WallCat and ThemeShowcase"),
                        _createElementVNode("li", null, "Created an empty state page"),
                        _createElementVNode("li", null, "Updated to Ionic 8")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Description")
                      ], -1),
                      _createTextVNode(" The full catalog of apps created by Puffercat as well as ones currently in development. If you don't have access to Google Play store on your device, you can download all of my Android apps here, from the official source.", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Screenshots")
                      ], -1),
                      _createElementVNode("div", { class: "scrollScreenshots" }, [
                        _createElementVNode("img", {
                          src: _imports_9,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_10,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_11,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_12,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_13,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_14,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_15,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_16,
                          class: "screenshot"
                        })
                      ], -1),
                      _createElementVNode("br", null, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Links")
                      ], -1),
                      _createElementVNode("a", {
                        href: "https://apps.puffercat.xyz",
                        class: ""
                      }, "Website", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://puffercatchannel.t.me",
                        class: ""
                      }, "Telegram channel", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://pufferchat.t.me",
                        class: ""
                      }, "Telegram chat", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://puffercat.t.me",
                        class: ""
                      }, "Telegram DM", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://twitter.com/@puffercatt",
                        class: ""
                      }, "Twitter", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "mailto:apps@puffercat.xyz",
                        class: ""
                      }, "E-mail", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://github.com/KZacharski/PuffercatApps",
                        class: ""
                      }, "GitHub repo", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}